/**
 * 언어 타입 또는 languageId로 파일 확장자 반환
 * @param {string|number} languageTypeOrId - 언어 타입 문자열 또는 LANGUAGE_OPTIONS의 languageId
 * @returns {string} 파일 확장자
 */
export const getExtensionFromLanguage = (languageTypeOrId) => {
  if (languageTypeOrId == null || languageTypeOrId === '') return 'md';

  // languageId (숫자)인 경우
  if (typeof languageTypeOrId === 'number') {
    const idMap = {
      1: 'py',   // Python
      2: 'java', // Java
      3: 'c',    // C
      4: 'cpp',  // CPP
      5: 'cs',   // CSharp
      6: 'js',   // NodeJS
      7: 'js',   // JavaScript
    };
    return idMap[languageTypeOrId] ?? 'md';
  }

  // 언어 타입 문자열인 경우
  const t = String(languageTypeOrId).toLowerCase();
  if (t.includes('python') || t === 'py') return 'py';
  if (t.includes('java')) return 'java';
  if (t === 'c') return 'c';
  if (t.includes('cpp') || t.includes('c++')) return 'cpp';
  if (t.includes('csharp') || t.includes('c#')) return 'cs';
  if (t.includes('javascript') || t.includes('node') || t.includes('js')) return 'js';
  return 'md';
};
